
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/engineering-management-for-the-rest-of-us",
      function () {
        return require("private-next-pages/books/engineering-management-for-the-rest-of-us.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/engineering-management-for-the-rest-of-us"])
      });
    }
  